/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VersionRouteImport } from './routes/version'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StoryboardIndexRouteImport } from './routes/storyboard/index'
import { Route as Reset_passwordIndexRouteImport } from './routes/reset_password/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as LocationIndexRouteImport } from './routes/location/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as WorkerWorkerCodeRouteImport } from './routes/worker/$workerCode'
import { Route as DashboardManagerRouteImport } from './routes/dashboard/manager'
import { Route as DashboardWorkerRouteRouteImport } from './routes/dashboard/worker/route'
import { Route as DashboardCustomerRouteRouteImport } from './routes/dashboard/customer/route'
import { Route as DashboardAgencyRouteRouteImport } from './routes/dashboard/agency/route'
import { Route as DashboardAdminRouteRouteImport } from './routes/dashboard/admin/route'
import { Route as InviteEmailIndexRouteImport } from './routes/invite/$email/index'
import { Route as DashboardWorkerIndexRouteImport } from './routes/dashboard/worker/index'
import { Route as DashboardProfileIndexRouteImport } from './routes/dashboard/profile/index'
import { Route as DashboardCustomerIndexRouteImport } from './routes/dashboard/customer/index'
import { Route as DashboardAgencyIndexRouteImport } from './routes/dashboard/agency/index'
import { Route as DashboardAdminIndexRouteImport } from './routes/dashboard/admin/index'
import { Route as ClockShortCodeIndexRouteImport } from './routes/clock/$shortCode/index'
import { Route as ClockInClockInIdIndexRouteImport } from './routes/clock-in/$clockInId/index'
import { Route as DashboardAdminTrashRouteRouteImport } from './routes/dashboard/admin/trash/route'
import { Route as DashboardCustomerProjectsIndexRouteImport } from './routes/dashboard/customer/projects/index'
import { Route as DashboardAgencyTime_trackingIndexRouteImport } from './routes/dashboard/agency/time_tracking/index'
import { Route as DashboardAdminWorkersIndexRouteImport } from './routes/dashboard/admin/workers/index'
import { Route as DashboardAdminWorker_messagesIndexRouteImport } from './routes/dashboard/admin/worker_messages/index'
import { Route as DashboardAdminUsersIndexRouteImport } from './routes/dashboard/admin/users/index'
import { Route as DashboardAdminTrashIndexRouteImport } from './routes/dashboard/admin/trash/index'
import { Route as DashboardAdminTime_trackingIndexRouteImport } from './routes/dashboard/admin/time_tracking/index'
import { Route as DashboardAdminTasksIndexRouteImport } from './routes/dashboard/admin/tasks/index'
import { Route as DashboardAdminSms_historyIndexRouteImport } from './routes/dashboard/admin/sms_history/index'
import { Route as DashboardAdminProjectsIndexRouteImport } from './routes/dashboard/admin/projects/index'
import { Route as DashboardAdminEvent_logsIndexRouteImport } from './routes/dashboard/admin/event_logs/index'
import { Route as DashboardAdminDebugWorkersIndexRouteImport } from './routes/dashboard/admin/debugWorkers/index'
import { Route as DashboardAdminCustomersIndexRouteImport } from './routes/dashboard/admin/customers/index'
import { Route as DashboardAdminConfigIndexRouteImport } from './routes/dashboard/admin/config/index'
import { Route as DashboardAdminChatIndexRouteImport } from './routes/dashboard/admin/chat/index'
import { Route as DashboardAdminAgenciesIndexRouteImport } from './routes/dashboard/admin/agencies/index'
import { Route as ClockInClockInIdChatIndexRouteImport } from './routes/clock-in/$clockInId/chat/index'
import { Route as DashboardAdminTrashWorkersRouteImport } from './routes/dashboard/admin/trash/workers'
import { Route as DashboardAdminTrashUsersRouteImport } from './routes/dashboard/admin/trash/users'
import { Route as DashboardAdminTrashProjectHoursRouteImport } from './routes/dashboard/admin/trash/project-hours'
import { Route as DashboardAdminTrashAgenciesRouteImport } from './routes/dashboard/admin/trash/agencies'
import { Route as DashboardAdminProjectsCreateRouteImport } from './routes/dashboard/admin/projects/create'
import { Route as DashboardAdminCustomersCreateRouteImport } from './routes/dashboard/admin/customers/create'
import { Route as DashboardAdminAgenciesCreateRouteImport } from './routes/dashboard/admin/agencies/create'
import { Route as DashboardAdminProjectsProjectIdRouteRouteImport } from './routes/dashboard/admin/projects/$projectId/route'
import { Route as DashboardCustomerProjectsProjectIdIndexRouteImport } from './routes/dashboard/customer/projects/$projectId/index'
import { Route as DashboardAgencyWorkersWorkerIdIndexRouteImport } from './routes/dashboard/agency/workers/$workerId/index'
import { Route as DashboardAdminWorkersWorkerIdIndexRouteImport } from './routes/dashboard/admin/workers/$workerId/index'
import { Route as DashboardAdminWorker_messagesWorkerIdIndexRouteImport } from './routes/dashboard/admin/worker_messages/$workerId/index'
import { Route as DashboardAdminProjectsProjectIdIndexRouteImport } from './routes/dashboard/admin/projects/$projectId/index'
import { Route as DashboardAdminDebugWorkersWorkerIdIndexRouteImport } from './routes/dashboard/admin/debugWorkers/$workerId/index'
import { Route as DashboardAdminCustomersCustomerIdIndexRouteImport } from './routes/dashboard/admin/customers/$customerId/index'
import { Route as DashboardAdminChatChatIdIndexRouteImport } from './routes/dashboard/admin/chat/$chatId/index'
import { Route as DashboardAdminAgenciesAgencyIdIndexRouteImport } from './routes/dashboard/admin/agencies/$agencyId/index'
import { Route as DashboardAdminProjectsProjectIdTrashIndexRouteImport } from './routes/dashboard/admin/projects/$projectId/trash/index'
import { Route as DashboardAdminProjectsProjectIdTimelineIndexRouteImport } from './routes/dashboard/admin/projects/$projectId/timeline/index'
import { Route as DashboardAdminProjectsProjectIdTasksIndexRouteImport } from './routes/dashboard/admin/projects/$projectId/tasks/index'
import { Route as DashboardAdminProjectsProjectIdScheduleIndexRouteImport } from './routes/dashboard/admin/projects/$projectId/schedule/index'
import { Route as DashboardAdminProjectsProjectIdNotesIndexRouteImport } from './routes/dashboard/admin/projects/$projectId/notes/index'
import { Route as DashboardAdminProjectsProjectIdHoursIndexRouteImport } from './routes/dashboard/admin/projects/$projectId/hours/index'
import { Route as DashboardAdminProjectsProjectIdDebug_audit_logsIndexRouteImport } from './routes/dashboard/admin/projects/$projectId/debug_audit_logs/index'
import { Route as DashboardAdminProjectsProjectIdAudit_logsIndexRouteImport } from './routes/dashboard/admin/projects/$projectId/audit_logs/index'

const VersionRoute = VersionRouteImport.update({
  id: '/version',
  path: '/version',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StoryboardIndexRoute = StoryboardIndexRouteImport.update({
  id: '/storyboard/',
  path: '/storyboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const Reset_passwordIndexRoute = Reset_passwordIndexRouteImport.update({
  id: '/reset_password/',
  path: '/reset_password/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationIndexRoute = LocationIndexRouteImport.update({
  id: '/location/',
  path: '/location/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const WorkerWorkerCodeRoute = WorkerWorkerCodeRouteImport.update({
  id: '/worker/$workerCode',
  path: '/worker/$workerCode',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardManagerRoute = DashboardManagerRouteImport.update({
  id: '/manager',
  path: '/manager',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardWorkerRouteRoute = DashboardWorkerRouteRouteImport.update({
  id: '/worker',
  path: '/worker',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCustomerRouteRoute = DashboardCustomerRouteRouteImport.update({
  id: '/customer',
  path: '/customer',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAgencyRouteRoute = DashboardAgencyRouteRouteImport.update({
  id: '/agency',
  path: '/agency',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAdminRouteRoute = DashboardAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const InviteEmailIndexRoute = InviteEmailIndexRouteImport.update({
  id: '/invite/$email/',
  path: '/invite/$email/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardWorkerIndexRoute = DashboardWorkerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardWorkerRouteRoute,
} as any)
const DashboardProfileIndexRoute = DashboardProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCustomerIndexRoute = DashboardCustomerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardCustomerRouteRoute,
} as any)
const DashboardAgencyIndexRoute = DashboardAgencyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardAgencyRouteRoute,
} as any)
const DashboardAdminIndexRoute = DashboardAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)
const ClockShortCodeIndexRoute = ClockShortCodeIndexRouteImport.update({
  id: '/clock/$shortCode/',
  path: '/clock/$shortCode/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClockInClockInIdIndexRoute = ClockInClockInIdIndexRouteImport.update({
  id: '/clock-in/$clockInId/',
  path: '/clock-in/$clockInId/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardAdminTrashRouteRoute =
  DashboardAdminTrashRouteRouteImport.update({
    id: '/trash',
    path: '/trash',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardCustomerProjectsIndexRoute =
  DashboardCustomerProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => DashboardCustomerRouteRoute,
  } as any)
const DashboardAgencyTime_trackingIndexRoute =
  DashboardAgencyTime_trackingIndexRouteImport.update({
    id: '/time_tracking/',
    path: '/time_tracking/',
    getParentRoute: () => DashboardAgencyRouteRoute,
  } as any)
const DashboardAdminWorkersIndexRoute =
  DashboardAdminWorkersIndexRouteImport.update({
    id: '/workers/',
    path: '/workers/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminWorker_messagesIndexRoute =
  DashboardAdminWorker_messagesIndexRouteImport.update({
    id: '/worker_messages/',
    path: '/worker_messages/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminUsersIndexRoute =
  DashboardAdminUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminTrashIndexRoute =
  DashboardAdminTrashIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAdminTrashRouteRoute,
  } as any)
const DashboardAdminTime_trackingIndexRoute =
  DashboardAdminTime_trackingIndexRouteImport.update({
    id: '/time_tracking/',
    path: '/time_tracking/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminTasksIndexRoute =
  DashboardAdminTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminSms_historyIndexRoute =
  DashboardAdminSms_historyIndexRouteImport.update({
    id: '/sms_history/',
    path: '/sms_history/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminProjectsIndexRoute =
  DashboardAdminProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminEvent_logsIndexRoute =
  DashboardAdminEvent_logsIndexRouteImport.update({
    id: '/event_logs/',
    path: '/event_logs/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminDebugWorkersIndexRoute =
  DashboardAdminDebugWorkersIndexRouteImport.update({
    id: '/debugWorkers/',
    path: '/debugWorkers/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminCustomersIndexRoute =
  DashboardAdminCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminConfigIndexRoute =
  DashboardAdminConfigIndexRouteImport.update({
    id: '/config/',
    path: '/config/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminChatIndexRoute = DashboardAdminChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)
const DashboardAdminAgenciesIndexRoute =
  DashboardAdminAgenciesIndexRouteImport.update({
    id: '/agencies/',
    path: '/agencies/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const ClockInClockInIdChatIndexRoute =
  ClockInClockInIdChatIndexRouteImport.update({
    id: '/clock-in/$clockInId/chat/',
    path: '/clock-in/$clockInId/chat/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardAdminTrashWorkersRoute =
  DashboardAdminTrashWorkersRouteImport.update({
    id: '/workers',
    path: '/workers',
    getParentRoute: () => DashboardAdminTrashRouteRoute,
  } as any)
const DashboardAdminTrashUsersRoute =
  DashboardAdminTrashUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => DashboardAdminTrashRouteRoute,
  } as any)
const DashboardAdminTrashProjectHoursRoute =
  DashboardAdminTrashProjectHoursRouteImport.update({
    id: '/project-hours',
    path: '/project-hours',
    getParentRoute: () => DashboardAdminTrashRouteRoute,
  } as any)
const DashboardAdminTrashAgenciesRoute =
  DashboardAdminTrashAgenciesRouteImport.update({
    id: '/agencies',
    path: '/agencies',
    getParentRoute: () => DashboardAdminTrashRouteRoute,
  } as any)
const DashboardAdminProjectsCreateRoute =
  DashboardAdminProjectsCreateRouteImport.update({
    id: '/projects/create',
    path: '/projects/create',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminCustomersCreateRoute =
  DashboardAdminCustomersCreateRouteImport.update({
    id: '/customers/create',
    path: '/customers/create',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminAgenciesCreateRoute =
  DashboardAdminAgenciesCreateRouteImport.update({
    id: '/agencies/create',
    path: '/agencies/create',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminProjectsProjectIdRouteRoute =
  DashboardAdminProjectsProjectIdRouteRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardCustomerProjectsProjectIdIndexRoute =
  DashboardCustomerProjectsProjectIdIndexRouteImport.update({
    id: '/projects/$projectId/',
    path: '/projects/$projectId/',
    getParentRoute: () => DashboardCustomerRouteRoute,
  } as any)
const DashboardAgencyWorkersWorkerIdIndexRoute =
  DashboardAgencyWorkersWorkerIdIndexRouteImport.update({
    id: '/workers/$workerId/',
    path: '/workers/$workerId/',
    getParentRoute: () => DashboardAgencyRouteRoute,
  } as any)
const DashboardAdminWorkersWorkerIdIndexRoute =
  DashboardAdminWorkersWorkerIdIndexRouteImport.update({
    id: '/workers/$workerId/',
    path: '/workers/$workerId/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminWorker_messagesWorkerIdIndexRoute =
  DashboardAdminWorker_messagesWorkerIdIndexRouteImport.update({
    id: '/worker_messages/$workerId/',
    path: '/worker_messages/$workerId/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminProjectsProjectIdIndexRoute =
  DashboardAdminProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAdminProjectsProjectIdRouteRoute,
  } as any)
const DashboardAdminDebugWorkersWorkerIdIndexRoute =
  DashboardAdminDebugWorkersWorkerIdIndexRouteImport.update({
    id: '/debugWorkers/$workerId/',
    path: '/debugWorkers/$workerId/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminCustomersCustomerIdIndexRoute =
  DashboardAdminCustomersCustomerIdIndexRouteImport.update({
    id: '/customers/$customerId/',
    path: '/customers/$customerId/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminChatChatIdIndexRoute =
  DashboardAdminChatChatIdIndexRouteImport.update({
    id: '/chat/$chatId/',
    path: '/chat/$chatId/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminAgenciesAgencyIdIndexRoute =
  DashboardAdminAgenciesAgencyIdIndexRouteImport.update({
    id: '/agencies/$agencyId/',
    path: '/agencies/$agencyId/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminProjectsProjectIdTrashIndexRoute =
  DashboardAdminProjectsProjectIdTrashIndexRouteImport.update({
    id: '/trash/',
    path: '/trash/',
    getParentRoute: () => DashboardAdminProjectsProjectIdRouteRoute,
  } as any)
const DashboardAdminProjectsProjectIdTimelineIndexRoute =
  DashboardAdminProjectsProjectIdTimelineIndexRouteImport.update({
    id: '/timeline/',
    path: '/timeline/',
    getParentRoute: () => DashboardAdminProjectsProjectIdRouteRoute,
  } as any)
const DashboardAdminProjectsProjectIdTasksIndexRoute =
  DashboardAdminProjectsProjectIdTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => DashboardAdminProjectsProjectIdRouteRoute,
  } as any)
const DashboardAdminProjectsProjectIdScheduleIndexRoute =
  DashboardAdminProjectsProjectIdScheduleIndexRouteImport.update({
    id: '/schedule/',
    path: '/schedule/',
    getParentRoute: () => DashboardAdminProjectsProjectIdRouteRoute,
  } as any)
const DashboardAdminProjectsProjectIdNotesIndexRoute =
  DashboardAdminProjectsProjectIdNotesIndexRouteImport.update({
    id: '/notes/',
    path: '/notes/',
    getParentRoute: () => DashboardAdminProjectsProjectIdRouteRoute,
  } as any)
const DashboardAdminProjectsProjectIdHoursIndexRoute =
  DashboardAdminProjectsProjectIdHoursIndexRouteImport.update({
    id: '/hours/',
    path: '/hours/',
    getParentRoute: () => DashboardAdminProjectsProjectIdRouteRoute,
  } as any)
const DashboardAdminProjectsProjectIdDebug_audit_logsIndexRoute =
  DashboardAdminProjectsProjectIdDebug_audit_logsIndexRouteImport.update({
    id: '/debug_audit_logs/',
    path: '/debug_audit_logs/',
    getParentRoute: () => DashboardAdminProjectsProjectIdRouteRoute,
  } as any)
const DashboardAdminProjectsProjectIdAudit_logsIndexRoute =
  DashboardAdminProjectsProjectIdAudit_logsIndexRouteImport.update({
    id: '/audit_logs/',
    path: '/audit_logs/',
    getParentRoute: () => DashboardAdminProjectsProjectIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/version': typeof VersionRoute
  '/dashboard/admin': typeof DashboardAdminRouteRouteWithChildren
  '/dashboard/agency': typeof DashboardAgencyRouteRouteWithChildren
  '/dashboard/customer': typeof DashboardCustomerRouteRouteWithChildren
  '/dashboard/worker': typeof DashboardWorkerRouteRouteWithChildren
  '/dashboard/manager': typeof DashboardManagerRoute
  '/worker/$workerCode': typeof WorkerWorkerCodeRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/location/': typeof LocationIndexRoute
  '/login/': typeof LoginIndexRoute
  '/reset_password/': typeof Reset_passwordIndexRoute
  '/storyboard/': typeof StoryboardIndexRoute
  '/dashboard/admin/trash': typeof DashboardAdminTrashRouteRouteWithChildren
  '/clock-in/$clockInId/': typeof ClockInClockInIdIndexRoute
  '/clock/$shortCode/': typeof ClockShortCodeIndexRoute
  '/dashboard/admin/': typeof DashboardAdminIndexRoute
  '/dashboard/agency/': typeof DashboardAgencyIndexRoute
  '/dashboard/customer/': typeof DashboardCustomerIndexRoute
  '/dashboard/profile/': typeof DashboardProfileIndexRoute
  '/dashboard/worker/': typeof DashboardWorkerIndexRoute
  '/invite/$email/': typeof InviteEmailIndexRoute
  '/dashboard/admin/projects/$projectId': typeof DashboardAdminProjectsProjectIdRouteRouteWithChildren
  '/dashboard/admin/agencies/create': typeof DashboardAdminAgenciesCreateRoute
  '/dashboard/admin/customers/create': typeof DashboardAdminCustomersCreateRoute
  '/dashboard/admin/projects/create': typeof DashboardAdminProjectsCreateRoute
  '/dashboard/admin/trash/agencies': typeof DashboardAdminTrashAgenciesRoute
  '/dashboard/admin/trash/project-hours': typeof DashboardAdminTrashProjectHoursRoute
  '/dashboard/admin/trash/users': typeof DashboardAdminTrashUsersRoute
  '/dashboard/admin/trash/workers': typeof DashboardAdminTrashWorkersRoute
  '/clock-in/$clockInId/chat/': typeof ClockInClockInIdChatIndexRoute
  '/dashboard/admin/agencies/': typeof DashboardAdminAgenciesIndexRoute
  '/dashboard/admin/chat/': typeof DashboardAdminChatIndexRoute
  '/dashboard/admin/config/': typeof DashboardAdminConfigIndexRoute
  '/dashboard/admin/customers/': typeof DashboardAdminCustomersIndexRoute
  '/dashboard/admin/debugWorkers/': typeof DashboardAdminDebugWorkersIndexRoute
  '/dashboard/admin/event_logs/': typeof DashboardAdminEvent_logsIndexRoute
  '/dashboard/admin/projects/': typeof DashboardAdminProjectsIndexRoute
  '/dashboard/admin/sms_history/': typeof DashboardAdminSms_historyIndexRoute
  '/dashboard/admin/tasks/': typeof DashboardAdminTasksIndexRoute
  '/dashboard/admin/time_tracking/': typeof DashboardAdminTime_trackingIndexRoute
  '/dashboard/admin/trash/': typeof DashboardAdminTrashIndexRoute
  '/dashboard/admin/users/': typeof DashboardAdminUsersIndexRoute
  '/dashboard/admin/worker_messages/': typeof DashboardAdminWorker_messagesIndexRoute
  '/dashboard/admin/workers/': typeof DashboardAdminWorkersIndexRoute
  '/dashboard/agency/time_tracking/': typeof DashboardAgencyTime_trackingIndexRoute
  '/dashboard/customer/projects/': typeof DashboardCustomerProjectsIndexRoute
  '/dashboard/admin/agencies/$agencyId/': typeof DashboardAdminAgenciesAgencyIdIndexRoute
  '/dashboard/admin/chat/$chatId/': typeof DashboardAdminChatChatIdIndexRoute
  '/dashboard/admin/customers/$customerId/': typeof DashboardAdminCustomersCustomerIdIndexRoute
  '/dashboard/admin/debugWorkers/$workerId/': typeof DashboardAdminDebugWorkersWorkerIdIndexRoute
  '/dashboard/admin/projects/$projectId/': typeof DashboardAdminProjectsProjectIdIndexRoute
  '/dashboard/admin/worker_messages/$workerId/': typeof DashboardAdminWorker_messagesWorkerIdIndexRoute
  '/dashboard/admin/workers/$workerId/': typeof DashboardAdminWorkersWorkerIdIndexRoute
  '/dashboard/agency/workers/$workerId/': typeof DashboardAgencyWorkersWorkerIdIndexRoute
  '/dashboard/customer/projects/$projectId/': typeof DashboardCustomerProjectsProjectIdIndexRoute
  '/dashboard/admin/projects/$projectId/audit_logs/': typeof DashboardAdminProjectsProjectIdAudit_logsIndexRoute
  '/dashboard/admin/projects/$projectId/debug_audit_logs/': typeof DashboardAdminProjectsProjectIdDebug_audit_logsIndexRoute
  '/dashboard/admin/projects/$projectId/hours/': typeof DashboardAdminProjectsProjectIdHoursIndexRoute
  '/dashboard/admin/projects/$projectId/notes/': typeof DashboardAdminProjectsProjectIdNotesIndexRoute
  '/dashboard/admin/projects/$projectId/schedule/': typeof DashboardAdminProjectsProjectIdScheduleIndexRoute
  '/dashboard/admin/projects/$projectId/tasks/': typeof DashboardAdminProjectsProjectIdTasksIndexRoute
  '/dashboard/admin/projects/$projectId/timeline/': typeof DashboardAdminProjectsProjectIdTimelineIndexRoute
  '/dashboard/admin/projects/$projectId/trash/': typeof DashboardAdminProjectsProjectIdTrashIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/version': typeof VersionRoute
  '/dashboard/manager': typeof DashboardManagerRoute
  '/worker/$workerCode': typeof WorkerWorkerCodeRoute
  '/dashboard': typeof DashboardIndexRoute
  '/location': typeof LocationIndexRoute
  '/login': typeof LoginIndexRoute
  '/reset_password': typeof Reset_passwordIndexRoute
  '/storyboard': typeof StoryboardIndexRoute
  '/clock-in/$clockInId': typeof ClockInClockInIdIndexRoute
  '/clock/$shortCode': typeof ClockShortCodeIndexRoute
  '/dashboard/admin': typeof DashboardAdminIndexRoute
  '/dashboard/agency': typeof DashboardAgencyIndexRoute
  '/dashboard/customer': typeof DashboardCustomerIndexRoute
  '/dashboard/profile': typeof DashboardProfileIndexRoute
  '/dashboard/worker': typeof DashboardWorkerIndexRoute
  '/invite/$email': typeof InviteEmailIndexRoute
  '/dashboard/admin/agencies/create': typeof DashboardAdminAgenciesCreateRoute
  '/dashboard/admin/customers/create': typeof DashboardAdminCustomersCreateRoute
  '/dashboard/admin/projects/create': typeof DashboardAdminProjectsCreateRoute
  '/dashboard/admin/trash/agencies': typeof DashboardAdminTrashAgenciesRoute
  '/dashboard/admin/trash/project-hours': typeof DashboardAdminTrashProjectHoursRoute
  '/dashboard/admin/trash/users': typeof DashboardAdminTrashUsersRoute
  '/dashboard/admin/trash/workers': typeof DashboardAdminTrashWorkersRoute
  '/clock-in/$clockInId/chat': typeof ClockInClockInIdChatIndexRoute
  '/dashboard/admin/agencies': typeof DashboardAdminAgenciesIndexRoute
  '/dashboard/admin/chat': typeof DashboardAdminChatIndexRoute
  '/dashboard/admin/config': typeof DashboardAdminConfigIndexRoute
  '/dashboard/admin/customers': typeof DashboardAdminCustomersIndexRoute
  '/dashboard/admin/debugWorkers': typeof DashboardAdminDebugWorkersIndexRoute
  '/dashboard/admin/event_logs': typeof DashboardAdminEvent_logsIndexRoute
  '/dashboard/admin/projects': typeof DashboardAdminProjectsIndexRoute
  '/dashboard/admin/sms_history': typeof DashboardAdminSms_historyIndexRoute
  '/dashboard/admin/tasks': typeof DashboardAdminTasksIndexRoute
  '/dashboard/admin/time_tracking': typeof DashboardAdminTime_trackingIndexRoute
  '/dashboard/admin/trash': typeof DashboardAdminTrashIndexRoute
  '/dashboard/admin/users': typeof DashboardAdminUsersIndexRoute
  '/dashboard/admin/worker_messages': typeof DashboardAdminWorker_messagesIndexRoute
  '/dashboard/admin/workers': typeof DashboardAdminWorkersIndexRoute
  '/dashboard/agency/time_tracking': typeof DashboardAgencyTime_trackingIndexRoute
  '/dashboard/customer/projects': typeof DashboardCustomerProjectsIndexRoute
  '/dashboard/admin/agencies/$agencyId': typeof DashboardAdminAgenciesAgencyIdIndexRoute
  '/dashboard/admin/chat/$chatId': typeof DashboardAdminChatChatIdIndexRoute
  '/dashboard/admin/customers/$customerId': typeof DashboardAdminCustomersCustomerIdIndexRoute
  '/dashboard/admin/debugWorkers/$workerId': typeof DashboardAdminDebugWorkersWorkerIdIndexRoute
  '/dashboard/admin/projects/$projectId': typeof DashboardAdminProjectsProjectIdIndexRoute
  '/dashboard/admin/worker_messages/$workerId': typeof DashboardAdminWorker_messagesWorkerIdIndexRoute
  '/dashboard/admin/workers/$workerId': typeof DashboardAdminWorkersWorkerIdIndexRoute
  '/dashboard/agency/workers/$workerId': typeof DashboardAgencyWorkersWorkerIdIndexRoute
  '/dashboard/customer/projects/$projectId': typeof DashboardCustomerProjectsProjectIdIndexRoute
  '/dashboard/admin/projects/$projectId/audit_logs': typeof DashboardAdminProjectsProjectIdAudit_logsIndexRoute
  '/dashboard/admin/projects/$projectId/debug_audit_logs': typeof DashboardAdminProjectsProjectIdDebug_audit_logsIndexRoute
  '/dashboard/admin/projects/$projectId/hours': typeof DashboardAdminProjectsProjectIdHoursIndexRoute
  '/dashboard/admin/projects/$projectId/notes': typeof DashboardAdminProjectsProjectIdNotesIndexRoute
  '/dashboard/admin/projects/$projectId/schedule': typeof DashboardAdminProjectsProjectIdScheduleIndexRoute
  '/dashboard/admin/projects/$projectId/tasks': typeof DashboardAdminProjectsProjectIdTasksIndexRoute
  '/dashboard/admin/projects/$projectId/timeline': typeof DashboardAdminProjectsProjectIdTimelineIndexRoute
  '/dashboard/admin/projects/$projectId/trash': typeof DashboardAdminProjectsProjectIdTrashIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/version': typeof VersionRoute
  '/dashboard/admin': typeof DashboardAdminRouteRouteWithChildren
  '/dashboard/agency': typeof DashboardAgencyRouteRouteWithChildren
  '/dashboard/customer': typeof DashboardCustomerRouteRouteWithChildren
  '/dashboard/worker': typeof DashboardWorkerRouteRouteWithChildren
  '/dashboard/manager': typeof DashboardManagerRoute
  '/worker/$workerCode': typeof WorkerWorkerCodeRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/location/': typeof LocationIndexRoute
  '/login/': typeof LoginIndexRoute
  '/reset_password/': typeof Reset_passwordIndexRoute
  '/storyboard/': typeof StoryboardIndexRoute
  '/dashboard/admin/trash': typeof DashboardAdminTrashRouteRouteWithChildren
  '/clock-in/$clockInId/': typeof ClockInClockInIdIndexRoute
  '/clock/$shortCode/': typeof ClockShortCodeIndexRoute
  '/dashboard/admin/': typeof DashboardAdminIndexRoute
  '/dashboard/agency/': typeof DashboardAgencyIndexRoute
  '/dashboard/customer/': typeof DashboardCustomerIndexRoute
  '/dashboard/profile/': typeof DashboardProfileIndexRoute
  '/dashboard/worker/': typeof DashboardWorkerIndexRoute
  '/invite/$email/': typeof InviteEmailIndexRoute
  '/dashboard/admin/projects/$projectId': typeof DashboardAdminProjectsProjectIdRouteRouteWithChildren
  '/dashboard/admin/agencies/create': typeof DashboardAdminAgenciesCreateRoute
  '/dashboard/admin/customers/create': typeof DashboardAdminCustomersCreateRoute
  '/dashboard/admin/projects/create': typeof DashboardAdminProjectsCreateRoute
  '/dashboard/admin/trash/agencies': typeof DashboardAdminTrashAgenciesRoute
  '/dashboard/admin/trash/project-hours': typeof DashboardAdminTrashProjectHoursRoute
  '/dashboard/admin/trash/users': typeof DashboardAdminTrashUsersRoute
  '/dashboard/admin/trash/workers': typeof DashboardAdminTrashWorkersRoute
  '/clock-in/$clockInId/chat/': typeof ClockInClockInIdChatIndexRoute
  '/dashboard/admin/agencies/': typeof DashboardAdminAgenciesIndexRoute
  '/dashboard/admin/chat/': typeof DashboardAdminChatIndexRoute
  '/dashboard/admin/config/': typeof DashboardAdminConfigIndexRoute
  '/dashboard/admin/customers/': typeof DashboardAdminCustomersIndexRoute
  '/dashboard/admin/debugWorkers/': typeof DashboardAdminDebugWorkersIndexRoute
  '/dashboard/admin/event_logs/': typeof DashboardAdminEvent_logsIndexRoute
  '/dashboard/admin/projects/': typeof DashboardAdminProjectsIndexRoute
  '/dashboard/admin/sms_history/': typeof DashboardAdminSms_historyIndexRoute
  '/dashboard/admin/tasks/': typeof DashboardAdminTasksIndexRoute
  '/dashboard/admin/time_tracking/': typeof DashboardAdminTime_trackingIndexRoute
  '/dashboard/admin/trash/': typeof DashboardAdminTrashIndexRoute
  '/dashboard/admin/users/': typeof DashboardAdminUsersIndexRoute
  '/dashboard/admin/worker_messages/': typeof DashboardAdminWorker_messagesIndexRoute
  '/dashboard/admin/workers/': typeof DashboardAdminWorkersIndexRoute
  '/dashboard/agency/time_tracking/': typeof DashboardAgencyTime_trackingIndexRoute
  '/dashboard/customer/projects/': typeof DashboardCustomerProjectsIndexRoute
  '/dashboard/admin/agencies/$agencyId/': typeof DashboardAdminAgenciesAgencyIdIndexRoute
  '/dashboard/admin/chat/$chatId/': typeof DashboardAdminChatChatIdIndexRoute
  '/dashboard/admin/customers/$customerId/': typeof DashboardAdminCustomersCustomerIdIndexRoute
  '/dashboard/admin/debugWorkers/$workerId/': typeof DashboardAdminDebugWorkersWorkerIdIndexRoute
  '/dashboard/admin/projects/$projectId/': typeof DashboardAdminProjectsProjectIdIndexRoute
  '/dashboard/admin/worker_messages/$workerId/': typeof DashboardAdminWorker_messagesWorkerIdIndexRoute
  '/dashboard/admin/workers/$workerId/': typeof DashboardAdminWorkersWorkerIdIndexRoute
  '/dashboard/agency/workers/$workerId/': typeof DashboardAgencyWorkersWorkerIdIndexRoute
  '/dashboard/customer/projects/$projectId/': typeof DashboardCustomerProjectsProjectIdIndexRoute
  '/dashboard/admin/projects/$projectId/audit_logs/': typeof DashboardAdminProjectsProjectIdAudit_logsIndexRoute
  '/dashboard/admin/projects/$projectId/debug_audit_logs/': typeof DashboardAdminProjectsProjectIdDebug_audit_logsIndexRoute
  '/dashboard/admin/projects/$projectId/hours/': typeof DashboardAdminProjectsProjectIdHoursIndexRoute
  '/dashboard/admin/projects/$projectId/notes/': typeof DashboardAdminProjectsProjectIdNotesIndexRoute
  '/dashboard/admin/projects/$projectId/schedule/': typeof DashboardAdminProjectsProjectIdScheduleIndexRoute
  '/dashboard/admin/projects/$projectId/tasks/': typeof DashboardAdminProjectsProjectIdTasksIndexRoute
  '/dashboard/admin/projects/$projectId/timeline/': typeof DashboardAdminProjectsProjectIdTimelineIndexRoute
  '/dashboard/admin/projects/$projectId/trash/': typeof DashboardAdminProjectsProjectIdTrashIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/version'
    | '/dashboard/admin'
    | '/dashboard/agency'
    | '/dashboard/customer'
    | '/dashboard/worker'
    | '/dashboard/manager'
    | '/worker/$workerCode'
    | '/dashboard/'
    | '/location/'
    | '/login/'
    | '/reset_password/'
    | '/storyboard/'
    | '/dashboard/admin/trash'
    | '/clock-in/$clockInId/'
    | '/clock/$shortCode/'
    | '/dashboard/admin/'
    | '/dashboard/agency/'
    | '/dashboard/customer/'
    | '/dashboard/profile/'
    | '/dashboard/worker/'
    | '/invite/$email/'
    | '/dashboard/admin/projects/$projectId'
    | '/dashboard/admin/agencies/create'
    | '/dashboard/admin/customers/create'
    | '/dashboard/admin/projects/create'
    | '/dashboard/admin/trash/agencies'
    | '/dashboard/admin/trash/project-hours'
    | '/dashboard/admin/trash/users'
    | '/dashboard/admin/trash/workers'
    | '/clock-in/$clockInId/chat/'
    | '/dashboard/admin/agencies/'
    | '/dashboard/admin/chat/'
    | '/dashboard/admin/config/'
    | '/dashboard/admin/customers/'
    | '/dashboard/admin/debugWorkers/'
    | '/dashboard/admin/event_logs/'
    | '/dashboard/admin/projects/'
    | '/dashboard/admin/sms_history/'
    | '/dashboard/admin/tasks/'
    | '/dashboard/admin/time_tracking/'
    | '/dashboard/admin/trash/'
    | '/dashboard/admin/users/'
    | '/dashboard/admin/worker_messages/'
    | '/dashboard/admin/workers/'
    | '/dashboard/agency/time_tracking/'
    | '/dashboard/customer/projects/'
    | '/dashboard/admin/agencies/$agencyId/'
    | '/dashboard/admin/chat/$chatId/'
    | '/dashboard/admin/customers/$customerId/'
    | '/dashboard/admin/debugWorkers/$workerId/'
    | '/dashboard/admin/projects/$projectId/'
    | '/dashboard/admin/worker_messages/$workerId/'
    | '/dashboard/admin/workers/$workerId/'
    | '/dashboard/agency/workers/$workerId/'
    | '/dashboard/customer/projects/$projectId/'
    | '/dashboard/admin/projects/$projectId/audit_logs/'
    | '/dashboard/admin/projects/$projectId/debug_audit_logs/'
    | '/dashboard/admin/projects/$projectId/hours/'
    | '/dashboard/admin/projects/$projectId/notes/'
    | '/dashboard/admin/projects/$projectId/schedule/'
    | '/dashboard/admin/projects/$projectId/tasks/'
    | '/dashboard/admin/projects/$projectId/timeline/'
    | '/dashboard/admin/projects/$projectId/trash/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/version'
    | '/dashboard/manager'
    | '/worker/$workerCode'
    | '/dashboard'
    | '/location'
    | '/login'
    | '/reset_password'
    | '/storyboard'
    | '/clock-in/$clockInId'
    | '/clock/$shortCode'
    | '/dashboard/admin'
    | '/dashboard/agency'
    | '/dashboard/customer'
    | '/dashboard/profile'
    | '/dashboard/worker'
    | '/invite/$email'
    | '/dashboard/admin/agencies/create'
    | '/dashboard/admin/customers/create'
    | '/dashboard/admin/projects/create'
    | '/dashboard/admin/trash/agencies'
    | '/dashboard/admin/trash/project-hours'
    | '/dashboard/admin/trash/users'
    | '/dashboard/admin/trash/workers'
    | '/clock-in/$clockInId/chat'
    | '/dashboard/admin/agencies'
    | '/dashboard/admin/chat'
    | '/dashboard/admin/config'
    | '/dashboard/admin/customers'
    | '/dashboard/admin/debugWorkers'
    | '/dashboard/admin/event_logs'
    | '/dashboard/admin/projects'
    | '/dashboard/admin/sms_history'
    | '/dashboard/admin/tasks'
    | '/dashboard/admin/time_tracking'
    | '/dashboard/admin/trash'
    | '/dashboard/admin/users'
    | '/dashboard/admin/worker_messages'
    | '/dashboard/admin/workers'
    | '/dashboard/agency/time_tracking'
    | '/dashboard/customer/projects'
    | '/dashboard/admin/agencies/$agencyId'
    | '/dashboard/admin/chat/$chatId'
    | '/dashboard/admin/customers/$customerId'
    | '/dashboard/admin/debugWorkers/$workerId'
    | '/dashboard/admin/projects/$projectId'
    | '/dashboard/admin/worker_messages/$workerId'
    | '/dashboard/admin/workers/$workerId'
    | '/dashboard/agency/workers/$workerId'
    | '/dashboard/customer/projects/$projectId'
    | '/dashboard/admin/projects/$projectId/audit_logs'
    | '/dashboard/admin/projects/$projectId/debug_audit_logs'
    | '/dashboard/admin/projects/$projectId/hours'
    | '/dashboard/admin/projects/$projectId/notes'
    | '/dashboard/admin/projects/$projectId/schedule'
    | '/dashboard/admin/projects/$projectId/tasks'
    | '/dashboard/admin/projects/$projectId/timeline'
    | '/dashboard/admin/projects/$projectId/trash'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/version'
    | '/dashboard/admin'
    | '/dashboard/agency'
    | '/dashboard/customer'
    | '/dashboard/worker'
    | '/dashboard/manager'
    | '/worker/$workerCode'
    | '/dashboard/'
    | '/location/'
    | '/login/'
    | '/reset_password/'
    | '/storyboard/'
    | '/dashboard/admin/trash'
    | '/clock-in/$clockInId/'
    | '/clock/$shortCode/'
    | '/dashboard/admin/'
    | '/dashboard/agency/'
    | '/dashboard/customer/'
    | '/dashboard/profile/'
    | '/dashboard/worker/'
    | '/invite/$email/'
    | '/dashboard/admin/projects/$projectId'
    | '/dashboard/admin/agencies/create'
    | '/dashboard/admin/customers/create'
    | '/dashboard/admin/projects/create'
    | '/dashboard/admin/trash/agencies'
    | '/dashboard/admin/trash/project-hours'
    | '/dashboard/admin/trash/users'
    | '/dashboard/admin/trash/workers'
    | '/clock-in/$clockInId/chat/'
    | '/dashboard/admin/agencies/'
    | '/dashboard/admin/chat/'
    | '/dashboard/admin/config/'
    | '/dashboard/admin/customers/'
    | '/dashboard/admin/debugWorkers/'
    | '/dashboard/admin/event_logs/'
    | '/dashboard/admin/projects/'
    | '/dashboard/admin/sms_history/'
    | '/dashboard/admin/tasks/'
    | '/dashboard/admin/time_tracking/'
    | '/dashboard/admin/trash/'
    | '/dashboard/admin/users/'
    | '/dashboard/admin/worker_messages/'
    | '/dashboard/admin/workers/'
    | '/dashboard/agency/time_tracking/'
    | '/dashboard/customer/projects/'
    | '/dashboard/admin/agencies/$agencyId/'
    | '/dashboard/admin/chat/$chatId/'
    | '/dashboard/admin/customers/$customerId/'
    | '/dashboard/admin/debugWorkers/$workerId/'
    | '/dashboard/admin/projects/$projectId/'
    | '/dashboard/admin/worker_messages/$workerId/'
    | '/dashboard/admin/workers/$workerId/'
    | '/dashboard/agency/workers/$workerId/'
    | '/dashboard/customer/projects/$projectId/'
    | '/dashboard/admin/projects/$projectId/audit_logs/'
    | '/dashboard/admin/projects/$projectId/debug_audit_logs/'
    | '/dashboard/admin/projects/$projectId/hours/'
    | '/dashboard/admin/projects/$projectId/notes/'
    | '/dashboard/admin/projects/$projectId/schedule/'
    | '/dashboard/admin/projects/$projectId/tasks/'
    | '/dashboard/admin/projects/$projectId/timeline/'
    | '/dashboard/admin/projects/$projectId/trash/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  VersionRoute: typeof VersionRoute
  WorkerWorkerCodeRoute: typeof WorkerWorkerCodeRoute
  LocationIndexRoute: typeof LocationIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  Reset_passwordIndexRoute: typeof Reset_passwordIndexRoute
  StoryboardIndexRoute: typeof StoryboardIndexRoute
  ClockInClockInIdIndexRoute: typeof ClockInClockInIdIndexRoute
  ClockShortCodeIndexRoute: typeof ClockShortCodeIndexRoute
  InviteEmailIndexRoute: typeof InviteEmailIndexRoute
  ClockInClockInIdChatIndexRoute: typeof ClockInClockInIdChatIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/version': {
      id: '/version'
      path: '/version'
      fullPath: '/version'
      preLoaderRoute: typeof VersionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/storyboard/': {
      id: '/storyboard/'
      path: '/storyboard'
      fullPath: '/storyboard/'
      preLoaderRoute: typeof StoryboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset_password/': {
      id: '/reset_password/'
      path: '/reset_password'
      fullPath: '/reset_password/'
      preLoaderRoute: typeof Reset_passwordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/location/': {
      id: '/location/'
      path: '/location'
      fullPath: '/location/'
      preLoaderRoute: typeof LocationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/worker/$workerCode': {
      id: '/worker/$workerCode'
      path: '/worker/$workerCode'
      fullPath: '/worker/$workerCode'
      preLoaderRoute: typeof WorkerWorkerCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/manager': {
      id: '/dashboard/manager'
      path: '/manager'
      fullPath: '/dashboard/manager'
      preLoaderRoute: typeof DashboardManagerRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/worker': {
      id: '/dashboard/worker'
      path: '/worker'
      fullPath: '/dashboard/worker'
      preLoaderRoute: typeof DashboardWorkerRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/customer': {
      id: '/dashboard/customer'
      path: '/customer'
      fullPath: '/dashboard/customer'
      preLoaderRoute: typeof DashboardCustomerRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/agency': {
      id: '/dashboard/agency'
      path: '/agency'
      fullPath: '/dashboard/agency'
      preLoaderRoute: typeof DashboardAgencyRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/admin': {
      id: '/dashboard/admin'
      path: '/admin'
      fullPath: '/dashboard/admin'
      preLoaderRoute: typeof DashboardAdminRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/invite/$email/': {
      id: '/invite/$email/'
      path: '/invite/$email'
      fullPath: '/invite/$email/'
      preLoaderRoute: typeof InviteEmailIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/worker/': {
      id: '/dashboard/worker/'
      path: '/'
      fullPath: '/dashboard/worker/'
      preLoaderRoute: typeof DashboardWorkerIndexRouteImport
      parentRoute: typeof DashboardWorkerRouteRoute
    }
    '/dashboard/profile/': {
      id: '/dashboard/profile/'
      path: '/profile'
      fullPath: '/dashboard/profile/'
      preLoaderRoute: typeof DashboardProfileIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/customer/': {
      id: '/dashboard/customer/'
      path: '/'
      fullPath: '/dashboard/customer/'
      preLoaderRoute: typeof DashboardCustomerIndexRouteImport
      parentRoute: typeof DashboardCustomerRouteRoute
    }
    '/dashboard/agency/': {
      id: '/dashboard/agency/'
      path: '/'
      fullPath: '/dashboard/agency/'
      preLoaderRoute: typeof DashboardAgencyIndexRouteImport
      parentRoute: typeof DashboardAgencyRouteRoute
    }
    '/dashboard/admin/': {
      id: '/dashboard/admin/'
      path: '/'
      fullPath: '/dashboard/admin/'
      preLoaderRoute: typeof DashboardAdminIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/clock/$shortCode/': {
      id: '/clock/$shortCode/'
      path: '/clock/$shortCode'
      fullPath: '/clock/$shortCode/'
      preLoaderRoute: typeof ClockShortCodeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clock-in/$clockInId/': {
      id: '/clock-in/$clockInId/'
      path: '/clock-in/$clockInId'
      fullPath: '/clock-in/$clockInId/'
      preLoaderRoute: typeof ClockInClockInIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/admin/trash': {
      id: '/dashboard/admin/trash'
      path: '/trash'
      fullPath: '/dashboard/admin/trash'
      preLoaderRoute: typeof DashboardAdminTrashRouteRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/customer/projects/': {
      id: '/dashboard/customer/projects/'
      path: '/projects'
      fullPath: '/dashboard/customer/projects/'
      preLoaderRoute: typeof DashboardCustomerProjectsIndexRouteImport
      parentRoute: typeof DashboardCustomerRouteRoute
    }
    '/dashboard/agency/time_tracking/': {
      id: '/dashboard/agency/time_tracking/'
      path: '/time_tracking'
      fullPath: '/dashboard/agency/time_tracking/'
      preLoaderRoute: typeof DashboardAgencyTime_trackingIndexRouteImport
      parentRoute: typeof DashboardAgencyRouteRoute
    }
    '/dashboard/admin/workers/': {
      id: '/dashboard/admin/workers/'
      path: '/workers'
      fullPath: '/dashboard/admin/workers/'
      preLoaderRoute: typeof DashboardAdminWorkersIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/worker_messages/': {
      id: '/dashboard/admin/worker_messages/'
      path: '/worker_messages'
      fullPath: '/dashboard/admin/worker_messages/'
      preLoaderRoute: typeof DashboardAdminWorker_messagesIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/users/': {
      id: '/dashboard/admin/users/'
      path: '/users'
      fullPath: '/dashboard/admin/users/'
      preLoaderRoute: typeof DashboardAdminUsersIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/trash/': {
      id: '/dashboard/admin/trash/'
      path: '/'
      fullPath: '/dashboard/admin/trash/'
      preLoaderRoute: typeof DashboardAdminTrashIndexRouteImport
      parentRoute: typeof DashboardAdminTrashRouteRoute
    }
    '/dashboard/admin/time_tracking/': {
      id: '/dashboard/admin/time_tracking/'
      path: '/time_tracking'
      fullPath: '/dashboard/admin/time_tracking/'
      preLoaderRoute: typeof DashboardAdminTime_trackingIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/tasks/': {
      id: '/dashboard/admin/tasks/'
      path: '/tasks'
      fullPath: '/dashboard/admin/tasks/'
      preLoaderRoute: typeof DashboardAdminTasksIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/sms_history/': {
      id: '/dashboard/admin/sms_history/'
      path: '/sms_history'
      fullPath: '/dashboard/admin/sms_history/'
      preLoaderRoute: typeof DashboardAdminSms_historyIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/projects/': {
      id: '/dashboard/admin/projects/'
      path: '/projects'
      fullPath: '/dashboard/admin/projects/'
      preLoaderRoute: typeof DashboardAdminProjectsIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/event_logs/': {
      id: '/dashboard/admin/event_logs/'
      path: '/event_logs'
      fullPath: '/dashboard/admin/event_logs/'
      preLoaderRoute: typeof DashboardAdminEvent_logsIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/debugWorkers/': {
      id: '/dashboard/admin/debugWorkers/'
      path: '/debugWorkers'
      fullPath: '/dashboard/admin/debugWorkers/'
      preLoaderRoute: typeof DashboardAdminDebugWorkersIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/customers/': {
      id: '/dashboard/admin/customers/'
      path: '/customers'
      fullPath: '/dashboard/admin/customers/'
      preLoaderRoute: typeof DashboardAdminCustomersIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/config/': {
      id: '/dashboard/admin/config/'
      path: '/config'
      fullPath: '/dashboard/admin/config/'
      preLoaderRoute: typeof DashboardAdminConfigIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/chat/': {
      id: '/dashboard/admin/chat/'
      path: '/chat'
      fullPath: '/dashboard/admin/chat/'
      preLoaderRoute: typeof DashboardAdminChatIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/agencies/': {
      id: '/dashboard/admin/agencies/'
      path: '/agencies'
      fullPath: '/dashboard/admin/agencies/'
      preLoaderRoute: typeof DashboardAdminAgenciesIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/clock-in/$clockInId/chat/': {
      id: '/clock-in/$clockInId/chat/'
      path: '/clock-in/$clockInId/chat'
      fullPath: '/clock-in/$clockInId/chat/'
      preLoaderRoute: typeof ClockInClockInIdChatIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/admin/trash/workers': {
      id: '/dashboard/admin/trash/workers'
      path: '/workers'
      fullPath: '/dashboard/admin/trash/workers'
      preLoaderRoute: typeof DashboardAdminTrashWorkersRouteImport
      parentRoute: typeof DashboardAdminTrashRouteRoute
    }
    '/dashboard/admin/trash/users': {
      id: '/dashboard/admin/trash/users'
      path: '/users'
      fullPath: '/dashboard/admin/trash/users'
      preLoaderRoute: typeof DashboardAdminTrashUsersRouteImport
      parentRoute: typeof DashboardAdminTrashRouteRoute
    }
    '/dashboard/admin/trash/project-hours': {
      id: '/dashboard/admin/trash/project-hours'
      path: '/project-hours'
      fullPath: '/dashboard/admin/trash/project-hours'
      preLoaderRoute: typeof DashboardAdminTrashProjectHoursRouteImport
      parentRoute: typeof DashboardAdminTrashRouteRoute
    }
    '/dashboard/admin/trash/agencies': {
      id: '/dashboard/admin/trash/agencies'
      path: '/agencies'
      fullPath: '/dashboard/admin/trash/agencies'
      preLoaderRoute: typeof DashboardAdminTrashAgenciesRouteImport
      parentRoute: typeof DashboardAdminTrashRouteRoute
    }
    '/dashboard/admin/projects/create': {
      id: '/dashboard/admin/projects/create'
      path: '/projects/create'
      fullPath: '/dashboard/admin/projects/create'
      preLoaderRoute: typeof DashboardAdminProjectsCreateRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/customers/create': {
      id: '/dashboard/admin/customers/create'
      path: '/customers/create'
      fullPath: '/dashboard/admin/customers/create'
      preLoaderRoute: typeof DashboardAdminCustomersCreateRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/agencies/create': {
      id: '/dashboard/admin/agencies/create'
      path: '/agencies/create'
      fullPath: '/dashboard/admin/agencies/create'
      preLoaderRoute: typeof DashboardAdminAgenciesCreateRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/projects/$projectId': {
      id: '/dashboard/admin/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/dashboard/admin/projects/$projectId'
      preLoaderRoute: typeof DashboardAdminProjectsProjectIdRouteRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/customer/projects/$projectId/': {
      id: '/dashboard/customer/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/dashboard/customer/projects/$projectId/'
      preLoaderRoute: typeof DashboardCustomerProjectsProjectIdIndexRouteImport
      parentRoute: typeof DashboardCustomerRouteRoute
    }
    '/dashboard/agency/workers/$workerId/': {
      id: '/dashboard/agency/workers/$workerId/'
      path: '/workers/$workerId'
      fullPath: '/dashboard/agency/workers/$workerId/'
      preLoaderRoute: typeof DashboardAgencyWorkersWorkerIdIndexRouteImport
      parentRoute: typeof DashboardAgencyRouteRoute
    }
    '/dashboard/admin/workers/$workerId/': {
      id: '/dashboard/admin/workers/$workerId/'
      path: '/workers/$workerId'
      fullPath: '/dashboard/admin/workers/$workerId/'
      preLoaderRoute: typeof DashboardAdminWorkersWorkerIdIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/worker_messages/$workerId/': {
      id: '/dashboard/admin/worker_messages/$workerId/'
      path: '/worker_messages/$workerId'
      fullPath: '/dashboard/admin/worker_messages/$workerId/'
      preLoaderRoute: typeof DashboardAdminWorker_messagesWorkerIdIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/projects/$projectId/': {
      id: '/dashboard/admin/projects/$projectId/'
      path: '/'
      fullPath: '/dashboard/admin/projects/$projectId/'
      preLoaderRoute: typeof DashboardAdminProjectsProjectIdIndexRouteImport
      parentRoute: typeof DashboardAdminProjectsProjectIdRouteRoute
    }
    '/dashboard/admin/debugWorkers/$workerId/': {
      id: '/dashboard/admin/debugWorkers/$workerId/'
      path: '/debugWorkers/$workerId'
      fullPath: '/dashboard/admin/debugWorkers/$workerId/'
      preLoaderRoute: typeof DashboardAdminDebugWorkersWorkerIdIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/customers/$customerId/': {
      id: '/dashboard/admin/customers/$customerId/'
      path: '/customers/$customerId'
      fullPath: '/dashboard/admin/customers/$customerId/'
      preLoaderRoute: typeof DashboardAdminCustomersCustomerIdIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/chat/$chatId/': {
      id: '/dashboard/admin/chat/$chatId/'
      path: '/chat/$chatId'
      fullPath: '/dashboard/admin/chat/$chatId/'
      preLoaderRoute: typeof DashboardAdminChatChatIdIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/agencies/$agencyId/': {
      id: '/dashboard/admin/agencies/$agencyId/'
      path: '/agencies/$agencyId'
      fullPath: '/dashboard/admin/agencies/$agencyId/'
      preLoaderRoute: typeof DashboardAdminAgenciesAgencyIdIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/projects/$projectId/trash/': {
      id: '/dashboard/admin/projects/$projectId/trash/'
      path: '/trash'
      fullPath: '/dashboard/admin/projects/$projectId/trash/'
      preLoaderRoute: typeof DashboardAdminProjectsProjectIdTrashIndexRouteImport
      parentRoute: typeof DashboardAdminProjectsProjectIdRouteRoute
    }
    '/dashboard/admin/projects/$projectId/timeline/': {
      id: '/dashboard/admin/projects/$projectId/timeline/'
      path: '/timeline'
      fullPath: '/dashboard/admin/projects/$projectId/timeline/'
      preLoaderRoute: typeof DashboardAdminProjectsProjectIdTimelineIndexRouteImport
      parentRoute: typeof DashboardAdminProjectsProjectIdRouteRoute
    }
    '/dashboard/admin/projects/$projectId/tasks/': {
      id: '/dashboard/admin/projects/$projectId/tasks/'
      path: '/tasks'
      fullPath: '/dashboard/admin/projects/$projectId/tasks/'
      preLoaderRoute: typeof DashboardAdminProjectsProjectIdTasksIndexRouteImport
      parentRoute: typeof DashboardAdminProjectsProjectIdRouteRoute
    }
    '/dashboard/admin/projects/$projectId/schedule/': {
      id: '/dashboard/admin/projects/$projectId/schedule/'
      path: '/schedule'
      fullPath: '/dashboard/admin/projects/$projectId/schedule/'
      preLoaderRoute: typeof DashboardAdminProjectsProjectIdScheduleIndexRouteImport
      parentRoute: typeof DashboardAdminProjectsProjectIdRouteRoute
    }
    '/dashboard/admin/projects/$projectId/notes/': {
      id: '/dashboard/admin/projects/$projectId/notes/'
      path: '/notes'
      fullPath: '/dashboard/admin/projects/$projectId/notes/'
      preLoaderRoute: typeof DashboardAdminProjectsProjectIdNotesIndexRouteImport
      parentRoute: typeof DashboardAdminProjectsProjectIdRouteRoute
    }
    '/dashboard/admin/projects/$projectId/hours/': {
      id: '/dashboard/admin/projects/$projectId/hours/'
      path: '/hours'
      fullPath: '/dashboard/admin/projects/$projectId/hours/'
      preLoaderRoute: typeof DashboardAdminProjectsProjectIdHoursIndexRouteImport
      parentRoute: typeof DashboardAdminProjectsProjectIdRouteRoute
    }
    '/dashboard/admin/projects/$projectId/debug_audit_logs/': {
      id: '/dashboard/admin/projects/$projectId/debug_audit_logs/'
      path: '/debug_audit_logs'
      fullPath: '/dashboard/admin/projects/$projectId/debug_audit_logs/'
      preLoaderRoute: typeof DashboardAdminProjectsProjectIdDebug_audit_logsIndexRouteImport
      parentRoute: typeof DashboardAdminProjectsProjectIdRouteRoute
    }
    '/dashboard/admin/projects/$projectId/audit_logs/': {
      id: '/dashboard/admin/projects/$projectId/audit_logs/'
      path: '/audit_logs'
      fullPath: '/dashboard/admin/projects/$projectId/audit_logs/'
      preLoaderRoute: typeof DashboardAdminProjectsProjectIdAudit_logsIndexRouteImport
      parentRoute: typeof DashboardAdminProjectsProjectIdRouteRoute
    }
  }
}

interface DashboardAdminTrashRouteRouteChildren {
  DashboardAdminTrashAgenciesRoute: typeof DashboardAdminTrashAgenciesRoute
  DashboardAdminTrashProjectHoursRoute: typeof DashboardAdminTrashProjectHoursRoute
  DashboardAdminTrashUsersRoute: typeof DashboardAdminTrashUsersRoute
  DashboardAdminTrashWorkersRoute: typeof DashboardAdminTrashWorkersRoute
  DashboardAdminTrashIndexRoute: typeof DashboardAdminTrashIndexRoute
}

const DashboardAdminTrashRouteRouteChildren: DashboardAdminTrashRouteRouteChildren =
  {
    DashboardAdminTrashAgenciesRoute: DashboardAdminTrashAgenciesRoute,
    DashboardAdminTrashProjectHoursRoute: DashboardAdminTrashProjectHoursRoute,
    DashboardAdminTrashUsersRoute: DashboardAdminTrashUsersRoute,
    DashboardAdminTrashWorkersRoute: DashboardAdminTrashWorkersRoute,
    DashboardAdminTrashIndexRoute: DashboardAdminTrashIndexRoute,
  }

const DashboardAdminTrashRouteRouteWithChildren =
  DashboardAdminTrashRouteRoute._addFileChildren(
    DashboardAdminTrashRouteRouteChildren,
  )

interface DashboardAdminProjectsProjectIdRouteRouteChildren {
  DashboardAdminProjectsProjectIdIndexRoute: typeof DashboardAdminProjectsProjectIdIndexRoute
  DashboardAdminProjectsProjectIdAudit_logsIndexRoute: typeof DashboardAdminProjectsProjectIdAudit_logsIndexRoute
  DashboardAdminProjectsProjectIdDebug_audit_logsIndexRoute: typeof DashboardAdminProjectsProjectIdDebug_audit_logsIndexRoute
  DashboardAdminProjectsProjectIdHoursIndexRoute: typeof DashboardAdminProjectsProjectIdHoursIndexRoute
  DashboardAdminProjectsProjectIdNotesIndexRoute: typeof DashboardAdminProjectsProjectIdNotesIndexRoute
  DashboardAdminProjectsProjectIdScheduleIndexRoute: typeof DashboardAdminProjectsProjectIdScheduleIndexRoute
  DashboardAdminProjectsProjectIdTasksIndexRoute: typeof DashboardAdminProjectsProjectIdTasksIndexRoute
  DashboardAdminProjectsProjectIdTimelineIndexRoute: typeof DashboardAdminProjectsProjectIdTimelineIndexRoute
  DashboardAdminProjectsProjectIdTrashIndexRoute: typeof DashboardAdminProjectsProjectIdTrashIndexRoute
}

const DashboardAdminProjectsProjectIdRouteRouteChildren: DashboardAdminProjectsProjectIdRouteRouteChildren =
  {
    DashboardAdminProjectsProjectIdIndexRoute:
      DashboardAdminProjectsProjectIdIndexRoute,
    DashboardAdminProjectsProjectIdAudit_logsIndexRoute:
      DashboardAdminProjectsProjectIdAudit_logsIndexRoute,
    DashboardAdminProjectsProjectIdDebug_audit_logsIndexRoute:
      DashboardAdminProjectsProjectIdDebug_audit_logsIndexRoute,
    DashboardAdminProjectsProjectIdHoursIndexRoute:
      DashboardAdminProjectsProjectIdHoursIndexRoute,
    DashboardAdminProjectsProjectIdNotesIndexRoute:
      DashboardAdminProjectsProjectIdNotesIndexRoute,
    DashboardAdminProjectsProjectIdScheduleIndexRoute:
      DashboardAdminProjectsProjectIdScheduleIndexRoute,
    DashboardAdminProjectsProjectIdTasksIndexRoute:
      DashboardAdminProjectsProjectIdTasksIndexRoute,
    DashboardAdminProjectsProjectIdTimelineIndexRoute:
      DashboardAdminProjectsProjectIdTimelineIndexRoute,
    DashboardAdminProjectsProjectIdTrashIndexRoute:
      DashboardAdminProjectsProjectIdTrashIndexRoute,
  }

const DashboardAdminProjectsProjectIdRouteRouteWithChildren =
  DashboardAdminProjectsProjectIdRouteRoute._addFileChildren(
    DashboardAdminProjectsProjectIdRouteRouteChildren,
  )

interface DashboardAdminRouteRouteChildren {
  DashboardAdminTrashRouteRoute: typeof DashboardAdminTrashRouteRouteWithChildren
  DashboardAdminIndexRoute: typeof DashboardAdminIndexRoute
  DashboardAdminProjectsProjectIdRouteRoute: typeof DashboardAdminProjectsProjectIdRouteRouteWithChildren
  DashboardAdminAgenciesCreateRoute: typeof DashboardAdminAgenciesCreateRoute
  DashboardAdminCustomersCreateRoute: typeof DashboardAdminCustomersCreateRoute
  DashboardAdminProjectsCreateRoute: typeof DashboardAdminProjectsCreateRoute
  DashboardAdminAgenciesIndexRoute: typeof DashboardAdminAgenciesIndexRoute
  DashboardAdminChatIndexRoute: typeof DashboardAdminChatIndexRoute
  DashboardAdminConfigIndexRoute: typeof DashboardAdminConfigIndexRoute
  DashboardAdminCustomersIndexRoute: typeof DashboardAdminCustomersIndexRoute
  DashboardAdminDebugWorkersIndexRoute: typeof DashboardAdminDebugWorkersIndexRoute
  DashboardAdminEvent_logsIndexRoute: typeof DashboardAdminEvent_logsIndexRoute
  DashboardAdminProjectsIndexRoute: typeof DashboardAdminProjectsIndexRoute
  DashboardAdminSms_historyIndexRoute: typeof DashboardAdminSms_historyIndexRoute
  DashboardAdminTasksIndexRoute: typeof DashboardAdminTasksIndexRoute
  DashboardAdminTime_trackingIndexRoute: typeof DashboardAdminTime_trackingIndexRoute
  DashboardAdminUsersIndexRoute: typeof DashboardAdminUsersIndexRoute
  DashboardAdminWorker_messagesIndexRoute: typeof DashboardAdminWorker_messagesIndexRoute
  DashboardAdminWorkersIndexRoute: typeof DashboardAdminWorkersIndexRoute
  DashboardAdminAgenciesAgencyIdIndexRoute: typeof DashboardAdminAgenciesAgencyIdIndexRoute
  DashboardAdminChatChatIdIndexRoute: typeof DashboardAdminChatChatIdIndexRoute
  DashboardAdminCustomersCustomerIdIndexRoute: typeof DashboardAdminCustomersCustomerIdIndexRoute
  DashboardAdminDebugWorkersWorkerIdIndexRoute: typeof DashboardAdminDebugWorkersWorkerIdIndexRoute
  DashboardAdminWorker_messagesWorkerIdIndexRoute: typeof DashboardAdminWorker_messagesWorkerIdIndexRoute
  DashboardAdminWorkersWorkerIdIndexRoute: typeof DashboardAdminWorkersWorkerIdIndexRoute
}

const DashboardAdminRouteRouteChildren: DashboardAdminRouteRouteChildren = {
  DashboardAdminTrashRouteRoute: DashboardAdminTrashRouteRouteWithChildren,
  DashboardAdminIndexRoute: DashboardAdminIndexRoute,
  DashboardAdminProjectsProjectIdRouteRoute:
    DashboardAdminProjectsProjectIdRouteRouteWithChildren,
  DashboardAdminAgenciesCreateRoute: DashboardAdminAgenciesCreateRoute,
  DashboardAdminCustomersCreateRoute: DashboardAdminCustomersCreateRoute,
  DashboardAdminProjectsCreateRoute: DashboardAdminProjectsCreateRoute,
  DashboardAdminAgenciesIndexRoute: DashboardAdminAgenciesIndexRoute,
  DashboardAdminChatIndexRoute: DashboardAdminChatIndexRoute,
  DashboardAdminConfigIndexRoute: DashboardAdminConfigIndexRoute,
  DashboardAdminCustomersIndexRoute: DashboardAdminCustomersIndexRoute,
  DashboardAdminDebugWorkersIndexRoute: DashboardAdminDebugWorkersIndexRoute,
  DashboardAdminEvent_logsIndexRoute: DashboardAdminEvent_logsIndexRoute,
  DashboardAdminProjectsIndexRoute: DashboardAdminProjectsIndexRoute,
  DashboardAdminSms_historyIndexRoute: DashboardAdminSms_historyIndexRoute,
  DashboardAdminTasksIndexRoute: DashboardAdminTasksIndexRoute,
  DashboardAdminTime_trackingIndexRoute: DashboardAdminTime_trackingIndexRoute,
  DashboardAdminUsersIndexRoute: DashboardAdminUsersIndexRoute,
  DashboardAdminWorker_messagesIndexRoute:
    DashboardAdminWorker_messagesIndexRoute,
  DashboardAdminWorkersIndexRoute: DashboardAdminWorkersIndexRoute,
  DashboardAdminAgenciesAgencyIdIndexRoute:
    DashboardAdminAgenciesAgencyIdIndexRoute,
  DashboardAdminChatChatIdIndexRoute: DashboardAdminChatChatIdIndexRoute,
  DashboardAdminCustomersCustomerIdIndexRoute:
    DashboardAdminCustomersCustomerIdIndexRoute,
  DashboardAdminDebugWorkersWorkerIdIndexRoute:
    DashboardAdminDebugWorkersWorkerIdIndexRoute,
  DashboardAdminWorker_messagesWorkerIdIndexRoute:
    DashboardAdminWorker_messagesWorkerIdIndexRoute,
  DashboardAdminWorkersWorkerIdIndexRoute:
    DashboardAdminWorkersWorkerIdIndexRoute,
}

const DashboardAdminRouteRouteWithChildren =
  DashboardAdminRouteRoute._addFileChildren(DashboardAdminRouteRouteChildren)

interface DashboardAgencyRouteRouteChildren {
  DashboardAgencyIndexRoute: typeof DashboardAgencyIndexRoute
  DashboardAgencyTime_trackingIndexRoute: typeof DashboardAgencyTime_trackingIndexRoute
  DashboardAgencyWorkersWorkerIdIndexRoute: typeof DashboardAgencyWorkersWorkerIdIndexRoute
}

const DashboardAgencyRouteRouteChildren: DashboardAgencyRouteRouteChildren = {
  DashboardAgencyIndexRoute: DashboardAgencyIndexRoute,
  DashboardAgencyTime_trackingIndexRoute:
    DashboardAgencyTime_trackingIndexRoute,
  DashboardAgencyWorkersWorkerIdIndexRoute:
    DashboardAgencyWorkersWorkerIdIndexRoute,
}

const DashboardAgencyRouteRouteWithChildren =
  DashboardAgencyRouteRoute._addFileChildren(DashboardAgencyRouteRouteChildren)

interface DashboardCustomerRouteRouteChildren {
  DashboardCustomerIndexRoute: typeof DashboardCustomerIndexRoute
  DashboardCustomerProjectsIndexRoute: typeof DashboardCustomerProjectsIndexRoute
  DashboardCustomerProjectsProjectIdIndexRoute: typeof DashboardCustomerProjectsProjectIdIndexRoute
}

const DashboardCustomerRouteRouteChildren: DashboardCustomerRouteRouteChildren =
  {
    DashboardCustomerIndexRoute: DashboardCustomerIndexRoute,
    DashboardCustomerProjectsIndexRoute: DashboardCustomerProjectsIndexRoute,
    DashboardCustomerProjectsProjectIdIndexRoute:
      DashboardCustomerProjectsProjectIdIndexRoute,
  }

const DashboardCustomerRouteRouteWithChildren =
  DashboardCustomerRouteRoute._addFileChildren(
    DashboardCustomerRouteRouteChildren,
  )

interface DashboardWorkerRouteRouteChildren {
  DashboardWorkerIndexRoute: typeof DashboardWorkerIndexRoute
}

const DashboardWorkerRouteRouteChildren: DashboardWorkerRouteRouteChildren = {
  DashboardWorkerIndexRoute: DashboardWorkerIndexRoute,
}

const DashboardWorkerRouteRouteWithChildren =
  DashboardWorkerRouteRoute._addFileChildren(DashboardWorkerRouteRouteChildren)

interface DashboardRouteRouteChildren {
  DashboardAdminRouteRoute: typeof DashboardAdminRouteRouteWithChildren
  DashboardAgencyRouteRoute: typeof DashboardAgencyRouteRouteWithChildren
  DashboardCustomerRouteRoute: typeof DashboardCustomerRouteRouteWithChildren
  DashboardWorkerRouteRoute: typeof DashboardWorkerRouteRouteWithChildren
  DashboardManagerRoute: typeof DashboardManagerRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardProfileIndexRoute: typeof DashboardProfileIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardAdminRouteRoute: DashboardAdminRouteRouteWithChildren,
  DashboardAgencyRouteRoute: DashboardAgencyRouteRouteWithChildren,
  DashboardCustomerRouteRoute: DashboardCustomerRouteRouteWithChildren,
  DashboardWorkerRouteRoute: DashboardWorkerRouteRouteWithChildren,
  DashboardManagerRoute: DashboardManagerRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardProfileIndexRoute: DashboardProfileIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  VersionRoute: VersionRoute,
  WorkerWorkerCodeRoute: WorkerWorkerCodeRoute,
  LocationIndexRoute: LocationIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  Reset_passwordIndexRoute: Reset_passwordIndexRoute,
  StoryboardIndexRoute: StoryboardIndexRoute,
  ClockInClockInIdIndexRoute: ClockInClockInIdIndexRoute,
  ClockShortCodeIndexRoute: ClockShortCodeIndexRoute,
  InviteEmailIndexRoute: InviteEmailIndexRoute,
  ClockInClockInIdChatIndexRoute: ClockInClockInIdChatIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
